import { combineReducers } from 'redux';
import initialState from '../initialState';
import { default_start_date, default_end_date } from '../components/filters/filterPanel/FilterPanel';

const errors = (state = [], action) => {
  switch (action.type) {
    case 'SHOW_ERROR': return [
      ...state,
      action.error,
    ];
    case 'HIDE_ERRORS': return [];
    default: return state;
  }
};

const loginError = (state = null, action) => {
  switch (action.type) {
    case 'SHOW_LOGIN_ERROR': return action.error;
    default: return state;
  }
};

const loading = (state = false, action) => {
  switch (action.type) {
    case 'TOGGLE_LOADING': return ! state;
    default: return state;
  }
};

const fetchData = (state = initialState.fetchData, action) => {
  switch (action.type) {
    case 'INCREMENT_FETCH': return {
      ...state,
      fetches: state.fetches + 1,
    };
    case 'DECREMENT_FETCH': return {
      ...state,
      fetches: state.fetches - 1,
    };
    case 'RESET_FETCH': return {
      ...state,
      fetches: 0,
    };
    case 'FETCH_REPORTS': return {
      ...state,
      fetchReports: action.payload,
    };
    default: return state;
  }
};


const sidebarVisible = (state = false, action) => {
  switch (action.type) {
    case 'TOGGLE_SIDEBAR': return ! state;
    default: return state;
  }
};

const mfaAuthCode = (state = null, action) => {
  switch (action.type) {
    case 'SET_MFA_AUTH_CODE': return action.authenticationCode;
    default: return state;
  }
};

const session = (state = null, action) => {
  switch (action.type) {
    case 'LOG_IN': return action.session;
    default: return state;
  }
};

const reportsData = (state = {

}, action) => {
  switch (action.type) {
    case 'INITIALIZE_REPORT': return {
      ...state,
      [action.payload]: {
        data: null,
        descriptionExpanded: false,
        metaData: null,
      },
    };
    case 'ADD_REPORTS': return {
      ...state,
      [action.payload.alias]: {
        ...state[action.payload.alias],
        data: action.payload.report,
      },
    };
    case 'ADD_DESCRIPTION': return {
      ...state,
      [action.payload.alias]: {
        ...state[action.payload.alias],
        metaData: action.payload.report,
      },
    };
    case 'TOGGLE_DESCRIPTION': return {
      ...state,
      [action.payload]: {
        ...state[action.payload],
        descriptionExpanded: ! state[action.payload].descriptionExpanded,
      },
    };
    default: return state;
  }
};

const presistFilters = (state = initialState.presistFilters, action) => {
  switch (action.type) {
    case 'UPDATE_FILTER': return {
      ...state,
      ...action.payload,
    };
    default: return state;
  }
};

const contractData = (state = {

}, action) => {
  switch (action.type) {
    /* The API response will have only one element in the Array like below.
    [
      {
        contract_type: "short_term",
        end_date: "2020-08-10",
        max_avg_annual_transaction: "50000",
        oem_id: "0dfc7900",
        purchased_transactions: "5000000",
        start_date: "2019-01-01",
      }
    ]
    So picking the first item in the array to update contract data into the redux store. */
    case 'UPDATE_CONTRACT': return action.payload.length ? action.payload[0] : {
      ...state,
      end_date: default_end_date,
      start_date: default_start_date
    };
    default: return state;
  }
};

const isFilterUpdated = (state = false, action) => {
  switch (action.type) {
    case 'FILTER_UPDATED': return action.payload;
    default: return state;
  }
};

const isMeteringApi = (state = false, action) => {
  switch (action.type) {
    case 'METERING_API': return action.payload;
    default: return state;
  }
};

const addFilterExpanded = (state = false, action) => {
  switch (action.type) {
    case 'EXPAND_ADD_FILTER': return action.payload;
    default: return state;
  }
};


const appReducer = combineReducers({
  addFilterExpanded,
  contractData,
  errors,
  fetchData,
  isFilterUpdated,
  isMeteringApi,
  loading,
  loginError,
  mfaAuthCode,
  presistFilters,
  reportsData,
  session,
  sidebarVisible,
});

export default (state, action) => {
  if (action.type === 'LOG_OUT') {
    // eslint-disable-next-line no-param-reassign
    state = undefined;
  }
  return appReducer(state, action);
};
